import React from 'react';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';

export type ToastActionElement = React.ReactElement;

export interface ToastOptions {
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive';
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export interface ToastData extends ToastOptions {
  id: string;
}

export interface ToastProps extends ToastData {
  onDismiss: (id: string) => void;
}

export const Toast: React.FC<ToastProps> = ({
  id,
  title,
  description,
  variant = 'default',
  onDismiss,
}) => {
  React.useEffect(() => {
    const timer = setTimeout(() => {
      onDismiss(id);
    }, 5000);

    return () => clearTimeout(timer);
  }, [id, onDismiss]);

  return (
    <div
      className={cn(
        'pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all',
        variant === 'default' ? 'bg-white border-gray-200 text-gray-950' : 'bg-red-600 border-red-600 text-white'
      )}
    >
      <div className="grid gap-1">
        {title && <div className="text-sm font-semibold">{title}</div>}
        {description && <div className="text-sm opacity-90">{description}</div>}
      </div>
      <button
        onClick={() => onDismiss(id)}
        className={cn(
          "absolute right-2 top-2 rounded-md p-1 opacity-70 transition-opacity hover:opacity-100",
          variant === 'default' ? 'text-gray-950' : 'text-white'
        )}
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}; 